document.addEventListener('DOMContentLoaded', function () {

  const marquees = document.querySelectorAll('.marquee-text__track');

  marquees.forEach(track => {

    const wrapper = track.parentElement;
    const items = Array.from(track.children);
    const speed = parseFloat(track.dataset.speed) || 60;

    const wrapperWidth = wrapper.offsetWidth;
    let contentWidth = track.scrollWidth;
    let cloneCount = 0;

    while (contentWidth < wrapperWidth * 2 && cloneCount < 20) {
      items.forEach(item => {
        const clone = item.cloneNode(true);
        track.appendChild(clone);
      });
      contentWidth = track.scrollWidth;
      cloneCount++;
    }

    const duration = contentWidth / speed;

    track.style.animation = `scroll-left ${duration}s linear infinite`;

    track.addEventListener('animationiteration', () => {
      track.style.transition = 'none';
      track.style.transform = 'translateX(0)';
      setTimeout(() => {
        track.style.transition = 'transform 0s linear';
      }, 0);
    });

  });

});
